import { KeyOutlined, UserSwitchOutlined } from "@ant-design/icons";
import TabSelection from "../../components/SelectContent/TabSelection";
import { setSuperAdminTab } from "../../state/slices/generalSlice";
import AdminRoles from "./AdminRoles";
import ExternalAppsPage from "./ExternalAppsPage";

const menuItems = [
  {
    key: "admin-roles",
    label: "Admin Roles",
    icon: <UserSwitchOutlined />,
    component: <AdminRoles />,
  },
  {
    key: "external-apps",
    label: "External Apps",
    icon: <KeyOutlined />,
    component: <ExternalAppsPage />,
  },
];

const SuperAdminPage = () => {
  return (
    <TabSelection
      menuItems={menuItems}
      currentTabKey="superAdminCurrentTab"
      setTabAction={setSuperAdminTab}
    />
  );
};

export default SuperAdminPage;
